import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import { Paragraph } from "../components"

const Container = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.grey[10]};
  :last-child {
    border-bottom: none;
  }
`
const Heading = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: ${(props) => props.theme.fontSizes[16]};
  justify-content: space-between;
  line-height: normal;
`

const WhyContent = ({ why }) => {
  const [open, setOpen] = useState(false)
  return (
    <Container>
      <Heading
        onClick={(e) => {
          e.stopPropagation
          setOpen(!open)
        }}
      >
        <Paragraph
          dangerouslySetInnerHTML={{ __html: why.question }}
          px={{ desktop: 8, tablet: 0 }}
        />
      </Heading>
    </Container>
  )
}

WhyContent.propTypes = {
  why: PropTypes.object,
}

export default WhyContent
